import React from 'react'
import SignUpSelectionimg from '../../Assets/LoginSelection.png'
import Navbar from '../../Components/Navbar'
import { useNavigate } from 'react-router-dom'
import SignupImage from '../../Assets/Signup.png'

function SignUpSelection() {
  const navigate = useNavigate()

  return (
    <>
      <Navbar />
      <div className="flex min-h-screen bg-white">
        <div className="hidden md:flex w-1/2 items-center justify-center p-6 bg-gray-50">
          <img
            src={SignupImage}
            alt="illustration"
            className="max-w-md w-full h-[90vh] object-fill"
          />
        </div>

        <div className="flex w-full md:w-1/2 items-center justify-center px-6">
          <div className="max-w-sm w-full">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold">
                Let's <span className="text-blue-600">Get Started</span>
              </h1>
              <p className="text-gray-600 text-sm mt-2">
                Choose how you want to SignUp to continue
              </p>
            </div>

            <div className="flex flex-col gap-4">
              <button
                onClick={() => {
                  navigate('/ph-UserSignUp')
                }}
                className="py-3 rounded-lg text-white font-medium bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90 transition"
              >
                Sign Up as User
              </button>
              <button
                onClick={() => {
                  navigate('/SelectProfessionalTypeSignUp')
                }}
                className="py-3 rounded-lg text-white font-medium bg-gradient-to-r from-blue-500 to-red-500 hover:opacity-90 transition"
              >
                Sign Up as Professional
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignUpSelection
